import React, { useCallback, useEffect, useRef, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import "dayjs/locale/en-gb";
import { useLocation, useNavigate } from "react-router-dom";
import apiClient from "../../BaseUrl/apiClient.js";
import TokenService from "../../service/TokenService";
import DropdownfromDatabaseList from "../../CustomComponant/DropdownfromDatabaseList";
import dayjs from "dayjs";
import SriyanshCardHeader from "../../components/CardHeader";
import { BoxStyle } from "../../constantVaribles/constatanvariable";
import { FormControlLabel, Checkbox } from "@mui/material";
import EncryptService from "../../service/EncryptionService";
import ListHeaderTableComponent from "../../CustomComponant/ListHeaderTables";
import CustomTextField from "../../CustomComponant/CustomTextField ";
import DatePickerComponent from "../../CustomComponant/DateTimePickerField";
import NumericTextField from "../../CustomComponant/NeumericTextField";
import CustomDropdownMenu from "../../CustomComponant/DropDownMenu";
import TablewithSumFooter from "../../CustomComponant/TablewithSumFooter";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
function PoPage() {
  const navigate = useNavigate();
  const [POReturnData, setPOReturnData] = useState([]);
  const [IndReturnData, setIndReturnData] = useState([]);
  const [poNumber, setpoNumber] = useState("");
  const [poItemName, setpoItemName] = useState("");
  const [poValue, setpoValue] = useState("");
  const [poQuantity, setpoQuantity] = useState("");
  const [poDate, setpoDate] = useState(null);
  const [dpDate, setdpDate] = useState(null);
  const [unit, setunit] = useState("");
  const [units, setunits] = useState([]);
  const [indentNo, setindentNo] = useState("");

  const [indentConsigneeName, setindentConsigneeName] = useState("");
  const { state } = useLocation();

  const indentId = useState(state.indent_id);

  const [minCalDate, setMinCalDate] = useState(dayjs());

  const today = dayjs();
  const [error, setError] = useState("");
  const [errors, setErrors] = useState({});
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));

  const [selectedOption, setSelectedOption] = useState("");



  const [gemchecked, setgemChecked] = useState(false); // Default is false
  const [gemNumber, setGemNumber] = useState("GEMC-"); 
  const [gemDate, setGemDate] = useState(null);




  const [partyName, setPartyName] = useState("");
  const [partyAddress, setPartyAddress] = useState("");
  const [partyContact, setPartyContact] = useState("");
  const startRef = useRef(null);




  const handlegemChange = (event) => {
    let inputValue = event.target.value;

    // Ensure the input always starts with "GEMC-"
    if (!inputValue.startsWith("GEMC-")) {
      inputValue = "GEMC-";
    }

    // Restrict to maximum 16 characters
    if (inputValue.length <= 20) {
      setGemNumber(inputValue);
    }
  };


useEffect(() => {
  if (units.length === 0) return;

  // backend value
  const backendUnit = IndReturnData?.unit;

  if (backendUnit) {
    const exists = units.some(
      u => String(u.unitcode) === String(backendUnit)
    );

    setunit(exists ? backendUnit : "");
  }
}, [units, IndReturnData]);


  const handleClose = () => {
    navigate("../polist", { replace: true });
  };

  const handleQuantityChange = (value) => {
    setpoQuantity(value);
    // Update errors as needed; example here:
    setErrors({
      qty:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };
  const fetchUnit = async () => {
    try {
      const response = await apiClient.post("/unitList", {
        /* request payload if needed */
      });
      setunits(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };
  const handleValueChange = (value) => {
    setpoValue(value);
    // Update errors as needed; example here:
    setErrors({
      val:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const InsertPOData = async (e) => {
    e.preventDefault();








    let formErrors = {};

    //if (podateerror) formErrors.errPODate = "Invalid PO Date";
   


    if (!gemchecked) {  // If gemchecked is false
      setGemNumber(null);
      setGemDate(null);
    }

  
    if (!dpDate)
      {
        formErrors.errDPDate = "Invalid DP Date";
        //alert("Invalid Date");
      } 

      if (!poDate)
        {
          formErrors.errPODate = "Invalid PO Date";
          //alert("Invalid Date");
        } 

    if (
      !poQuantity ||
      poQuantity.length === 0 ||
      isNaN(parseFloat(poQuantity)) ||
      parseFloat(poQuantity) <= 0
    ) {
      formErrors.qty = "Qty should be more than zero";
    }

    if (!poValue || isNaN(parseFloat(poValue)) || parseFloat(poValue) <= 0) {
      formErrors.val = "Value should be more than zero";
    }

    if (!poNumber || poNumber.length !== 14) {
      formErrors.po = "PO Number length should be exactly 14 characters";
    }

    if (gemchecked && typeof gemNumber === "string" && gemNumber.trim().length !== 20) {
      formErrors.gemno = "GeM Contract Number length should be exactly 20 characters";
  }
   
    if (!poItemName || poItemName.length === 0) {
      formErrors.name = "Item Name Should not be Blank";
    }

    if (!partyName || partyName.length === 0) {
      formErrors.partyName = "Party Name Should not be Blank";
    }

    if (!partyAddress || partyAddress.length === 0) {
      formErrors.partyAddress = "Party Address Should not be Blank";
    }

    if (selectedOption.length === 0) {
      formErrors.selerr = "Indent Type Not Selected";
    }
    setErrors(formErrors);

    //console.log(formErrors);
    if (Object.keys(formErrors).length === 0) {
      
      
      const podt = new Date(poDate);
      const indentreceiptdt =
        podt.getFullYear() +
        "/" +
        parseInt(podt.getMonth() + 1) +
        "/" +
        podt.getDate();
      const dpdt = new Date(dpDate);
      const DP_date =
        dpdt.getFullYear() +
        "/" +
        parseInt(dpdt.getMonth() + 1) +
        "/" +
        dpdt.getDate();

        const gemdt = gemchecked ? new Date(gemDate) : null;
        const gem_date = gemdt
          ? `${gemdt.getFullYear()}/${String(gemdt.getMonth() + 1).padStart(2, "0")}/${String(gemdt.getDate()).padStart(2, "0")}`
          : null;


      apiClient
        .post("/poentry", {
          indentNum: indentNo,
          poNumber,
          poItemName,
          poQuantity,
          poValue,
          consignee: indentConsigneeName,
          poDate: indentreceiptdt,
          uname,
          dpdate: DP_date,
          ip,
          potype: selectedOption,
          party_name: partyName,
          party_address: partyAddress,
          party_contact: partyContact ? partyContact : '',
          unit,
          gemtype:gemchecked,
          gemno:gemchecked ? gemNumber:null,
          gemdate:gemchecked? gem_date:null,
        })
        .then(function (response) {
          setError(response.data);

          navigate("../polist", { replace: true });
        })
        .catch(function (error) {
          if (
            error.response.data &&
            error.response.data.code === "ER_DUP_ENTRY"
          ) {
            alert("Duplicate PO Not Allowed");
          } else {
            alert(error.response.data.code);
          }
        });
    }
  };

  // const getdata = useCallback(
  //   async (e) => {
  //     try {
  //       const response = await apiClient.post("/indentdetails", {
  //         uname: uname,
  //         indentNumber: String(indentId),
  //       });

  //       setIndReturnData(response.data[0]);

  //       setindentNo(IndReturnData.indnumber);

  //       setindentConsigneeName(IndReturnData.consignee);
  //       setpoItemName(IndReturnData.inditem);
  //       //console.log(response.data[0]);
  //       setpoValue(IndReturnData.POValue);
  //       setpoQuantity(IndReturnData.POQuantity);
  //      // setunit(IndReturnData.unit);
  //       const minValueDate =
  //         "'" + dayjs(IndReturnData.inddate).format("YYYY-MM-DD") + "'";

  //       setMinCalDate(dayjs(minValueDate));
  //     } catch (error) {
  //       setError(error.response ? error.response.data : error.message);
  //     }
  //   },
  //   [indentNo, IndReturnData.POQuantity]
  // );



const getdata = useCallback(async () => {
  try {
    const response = await apiClient.post("/indentdetails", {
      uname,
      indentNumber: String(indentId),
    });

    const data = response.data[0];

    setIndReturnData(data);
    setindentNo(data.indnumber);
    setindentConsigneeName(data.consignee);
    setpoItemName(data.inditem);
    setpoValue(data.POValue);
    setpoQuantity(data.POQuantity);

    setMinCalDate(dayjs(data.inddate));
  } catch (error) {
    setError(error.response ? error.response.data : error.message);
  }
}, [uname, indentId]);







  const getPOdata = useCallback(async () => {
    // console.log("Indent",indentNo?indentNo:'');
    if (!indentNo || indentNo.trim() === "") return;
    try {
      const response = await apiClient.post("/getPO_Data_ByIndent", {
        indentnumber: indentNo,
      });

      // Check if response is successful and has the data
      if (response.status === 200 && response.data) {
        setPOReturnData(response.data);
      } else {
        // Handle cases where response is not as expected
        //console.error("Failed to fetch PO data:", response);
      }
    } catch (err) {
      // Log the error to see what went wrong
      //console.error("Error fetching PO data:", err);
    }
  }, [indentNo, POReturnData]); // Use only `indentNo` unless `IndReturnData.POQuantity` is needed for some reason

  
  
  
  
  useEffect(() => {
    getdata();
    getPOdata();
    fetchUnit();
    if (startRef.current) {
      startRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      
    }

  }, []);

  // useEffect(() => {
  //   if (!gemchecked) {  // If gemchecked is false
  //     setGemNumber(null);
  //     setGemDate(null);
  //   }
  // }, [gemchecked]);


  const columns = [
    "PONumber",
    "PODate",
    "DPDate",
    "POItemName",
    "ItemQuantity",
    "ItemValue",
  ];

  const columnNames = [
    "PO Number",
    "PO Date",
    "DP Date",
    "PO ItemName",
    "PO Qty",
    "PO Value",
  ]; // keys from your data objects

  const headers = [
    ["Indent Number", "Indent Item Name", "Consignee"],
    ["Indent date", "Indent Quantity", "Indent Value"],
    ["", "Balance PO Quantity", "Balance PO Value"],
  ];

  const rows = [
    [indentNo, IndReturnData.inditem, IndReturnData.consignee],
    [IndReturnData.inddate, IndReturnData.quantity, IndReturnData.indvalue],
    ["", IndReturnData.POQuantity, IndReturnData.POValue],
  ];

  const menuoptions = [
    { value: "0", label: "Full Indent PO" },
    { value: "1", label: "Partial Indent PO" },
    { value: "2", label: "Final PO of Partial Indent" },
  ];

  const handleChange = (event) => {
    const inputValue = event.target.value.toUpperCase();
    // Remove any non-alphanumeric characters
    const alphanumericValue = inputValue.replace(/[^a-zA-Z0-9]/g, "");
    setpoNumber(alphanumericValue);
  };

  const handleDateChange = (newDate, setDate) => {
    if (newDate) {
      setDate(newDate);
      setErrors({ ...errors, errDate: false }); // Clear error if a valid date is selected
    } else {
      setErrors({ ...errors, errDate: true }); // Show error if date is cleared
    }
  };

  return (
  <>
    <style>
      {`
        /* =====================================================
           PO DATA ENTRY - DASHBOARD THEME
        ===================================================== */

        .po-entry-page {
          width: 100%;
          max-width: 100%;
          min-width: 0;

          padding: 12px;

          box-sizing: border-box;

          overflow-x: hidden;
        }


        /* =====================================================
           MAIN CARD
        ===================================================== */

        .po-entry-card {
          width: 100%;
          max-width: 100%;
          min-width: 0;

          background: #ffffff !important;

          border: 1px solid #dce5f0 !important;

          border-radius: 16px !important;

          box-shadow:
            0 6px 24px rgba(0, 68, 145, 0.10) !important;

          overflow: hidden;

          box-sizing: border-box;
        }


        /* =====================================================
           HEADER
        ===================================================== */

        .po-entry-header {
          width: 100%;

          padding: 18px 24px;

          background:
            linear-gradient(
              135deg,
              #0d47a1 0%,
              #1565c0 48%,
              #1976d2 100%
            );

          color: #ffffff;

          box-sizing: border-box;
        }


        .po-entry-title {
          margin: 0;

          font-size: 20px;

          font-weight: 700;

          line-height: 1.3;
        }


        .po-entry-subtitle {
          margin-top: 4px;

          font-size: 13px;

          opacity: 0.90;
        }


        /* =====================================================
           CONTENT
        ===================================================== */

        .po-entry-content {
          width: 100%;
          max-width: 100%;
          min-width: 0;

          padding: 20px 22px;

          box-sizing: border-box;
        }


        /* =====================================================
           SECTION TITLE
        ===================================================== */

        .po-section-title {
          display: flex;

          align-items: center;

          gap: 8px;

          margin-bottom: 12px;

          color: #1565c0;

          font-size: 14px;

          font-weight: 700;
        }


        .po-section-title::before {
          content: "";

          width: 4px;

          height: 18px;

          border-radius: 5px;

          background:
            linear-gradient(
              180deg,
              #0d47a1,
              #1976d2
            );
        }


        /* =====================================================
           INDENT DETAILS ACCORDION
        ===================================================== */

        .po-indent-accordion {
          width: 100%;

          margin-bottom: 20px !important;

          border: 1px solid #dce5f0 !important;

          border-radius: 12px !important;

          background: #ffffff !important;

          box-shadow:
            0 3px 12px rgba(0, 68, 145, 0.06) !important;

          overflow: hidden;
        }


        .po-indent-accordion::before {
          display: none !important;
        }


        .po-indent-summary {
          min-height: 48px !important;

          padding: 0 16px !important;

          background:
            linear-gradient(
              135deg,
              #f3f8ff,
              #eaf3ff
            ) !important;

          color: #0d47a1 !important;
        }


        .po-indent-summary .MuiTypography-root {
          font-size: 14px;

          font-weight: 700;
        }


        .po-indent-summary .MuiAccordionSummary-expandIconWrapper {
          color: #1565c0;
        }


        .po-indent-details {
          padding: 12px !important;

          background: #ffffff;
        }


        /* =====================================================
           PO FORM GRID
        ===================================================== */

        .po-form-grid {
          width: 100%;
          max-width: 100%;
          min-width: 0;

          display: grid;

          grid-template-columns:
            repeat(2, minmax(0, 1fr));

          gap: 16px;

          box-sizing: border-box;
        }


        .po-field {
          width: 100%;
          min-width: 0;

          box-sizing: border-box;
        }


        .po-full {
          grid-column: 1 / -1;
        }


        /* =====================================================
           SMALL THREE COLUMN ROW
        ===================================================== */

        .po-three-fields {
          grid-column: 1 / -1;

          display: grid;

          grid-template-columns:
            repeat(3, minmax(0, 1fr));

          gap: 16px;

          width: 100%;

          min-width: 0;
        }


        /* =====================================================
           GEM SECTION
        ===================================================== */

        .po-gem-section {
          grid-column: 1 / -1;

          display: grid;

          grid-template-columns:
            minmax(180px, 0.8fr)
            minmax(200px, 1fr)
            minmax(200px, 1fr);

          gap: 16px;

          padding: 15px;

          border: 1px solid #d7e5f5;

          border-radius: 12px;

          background:
            linear-gradient(
              135deg,
              #f8fbff,
              #f1f7ff
            );

          box-sizing: border-box;
        }


        .po-gem-check {
          display: flex;

          align-items: center;

          min-width: 0;
        }


        .po-gem-check .MuiFormControlLabel-label {
          color: #263238;

          font-size: 13px;

          font-weight: 600;
        }


        /* =====================================================
           EXISTING PO LIST
        ===================================================== */

        .po-list-section {
          width: 100%;

          max-width: 100%;

          min-width: 0;

          margin-top: 22px;

          overflow: hidden;
        }


        /* =====================================================
           ACTION AREA
        ===================================================== */

        .po-entry-actions {
          display: flex;

          align-items: center;

          justify-content: space-between;

          gap: 15px;

          width: 100%;

          margin-top: 25px;

          padding-top: 18px;

          border-top:
            1px solid #e1e8f0;

          box-sizing: border-box;
        }


        .po-entry-btn {
          min-width: 135px;

          min-height: 42px;

          padding: 10px 24px;

          border: none;

          border-radius: 10px;

          color: #ffffff;

          font-size: 14px;

          font-weight: 700;

          cursor: pointer;

          transition:
            transform 0.18s ease,
            box-shadow 0.18s ease;
        }


        .po-save-btn {
          background:
            linear-gradient(
              135deg,
              #0d47a1,
              #1976d2
            );

          box-shadow:
            0 4px 12px rgba(21,101,192,0.22);
        }


        .po-save-btn:hover {
          transform: translateY(-2px);

          box-shadow:
            0 7px 18px rgba(21,101,192,0.30);
        }


        .po-close-btn {
          background:
            linear-gradient(
              135deg,
              #c62828,
              #e53935
            );

          box-shadow:
            0 4px 12px rgba(198,40,40,0.18);
        }


        .po-close-btn:hover {
          transform: translateY(-2px);

          box-shadow:
            0 7px 18px rgba(198,40,40,0.28);
        }


        /* =====================================================
           TABLET
        ===================================================== */

        @media (max-width: 950px) {

          .po-form-grid {
            grid-template-columns:
              repeat(2, minmax(0, 1fr));

            gap: 13px;
          }


          .po-three-fields {
            gap: 13px;
          }


          .po-gem-section {
            grid-template-columns:
              1fr 1fr;
          }


          .po-gem-check {
            grid-column: 1 / -1;
          }
        }


        /* =====================================================
           MOBILE
        ===================================================== */

        @media (max-width: 600px) {

          .po-entry-page {
            padding: 6px;
          }


          .po-entry-card {
            border-radius: 12px !important;
          }


          .po-entry-header {
            padding: 15px 16px;
          }


          .po-entry-title {
            font-size: 17px;
          }


          .po-entry-subtitle {
            font-size: 11px;
          }


          .po-entry-content {
            padding: 15px;
          }


          .po-form-grid {
            grid-template-columns: 1fr;

            gap: 13px;
          }


          .po-full {
            grid-column: auto;
          }


          .po-three-fields {
            grid-column: auto;

            grid-template-columns: 1fr;

            gap: 13px;
          }


          .po-gem-section {
            grid-column: auto;

            grid-template-columns: 1fr;

            gap: 12px;

            padding: 12px;
          }


          .po-gem-check {
            grid-column: auto;
          }


          .po-indent-summary {
            padding: 0 12px !important;
          }


          .po-indent-details {
            padding: 8px !important;
          }


          .po-list-section {
            margin-top: 15px;

            overflow-x: auto;
          }


          .po-entry-actions {
            flex-direction: column;

            align-items: stretch;

            gap: 10px;

            margin-top: 20px;

            padding-top: 15px;
          }


          .po-entry-btn {
            width: 100%;

            min-height: 44px;
          }
        }


        /* =====================================================
           VERY SMALL MOBILE
        ===================================================== */

        @media (max-width: 400px) {

          .po-entry-page {
            padding: 4px;
          }


          .po-entry-header {
            padding: 13px;
          }


          .po-entry-title {
            font-size: 16px;
          }


          .po-entry-content {
            padding: 12px;
          }


          .po-indent-summary .MuiTypography-root {
            font-size: 12px;
          }
        }
      `}
    </style>


    {/* =========================================================
        PAGE
    ========================================================== */}

    <div className="po-entry-page">

      <Card className="po-entry-card">

        {/* =====================================================
            HEADER
        ====================================================== */}

        <div className="po-entry-header">

          <div className="po-entry-title">
            PO Data Entry
          </div>

          <div className="po-entry-subtitle">
            Enter purchase order, GeM, item and party details
          </div>

        </div>


        {/* =====================================================
            CONTENT
        ====================================================== */}

        <CardContent
          sx={{
            padding: 0,
            "&:last-child": {
              paddingBottom: 0,
            },
          }}
        >

          <div className="po-entry-content">


            {/* =================================================
                INDENT DETAILS
            ================================================== */}

            <Accordion
              defaultExpanded
              className="po-indent-accordion"
            >

              <AccordionSummary
                expandIcon={
                  <ArrowDownwardIcon />
                }
                aria-controls="panel1-content"
                id="panel1-header"
                className="po-indent-summary"
              >

                <Typography component="span">
                  Indent Details
                </Typography>

              </AccordionSummary>


              <AccordionDetails
                className="po-indent-details"
              >

                <ListHeaderTableComponent
                  headers={headers}
                  rows={rows}
                />

              </AccordionDetails>

            </Accordion>


            {/* =================================================
                PO INFORMATION
            ================================================== */}

            <div className="po-section-title">
              Purchase Order Information
            </div>


            <div className="po-form-grid">


              {/* =================================================
                  PO TYPE
              ================================================== */}

              <div className="po-field">

                <CustomDropdownMenu
                  options={menuoptions}
                  selectedOption={selectedOption}
                  handleOptionChange={handleOptionChange}
                  error={error}
                  menulabel="Select PO Type"
                />

              </div>


              {/* =================================================
                  PO NUMBER
              ================================================== */}

              <div className="po-field">

                <CustomTextField
                  label="PO Number (Only 14 Characters)*"
                  value={poNumber || ""}
                  onChange={handleChange}
                  placeholder="PO Number length should be exactly 14 characters"
                  maxLength={14}
                  error={!!errors.po}
                  helperText={errors.po}
                />

              </div>


              {/* =================================================
                  GEM SECTION
              ================================================== */}

              <div className="po-gem-section">

                <div className="po-gem-check">

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={gemchecked}
                        onChange={(e) =>
                          setgemChecked(
                            e.target.checked
                          )
                        }
                        color="primary"
                      />
                    }
                    label="Select if GeM Contract"
                  />

                </div>


                <div className="po-field">

                  <CustomTextField
                    label="GeM Contract Number (20 Characters)*"
                    value={gemNumber || ""}
                    onChange={handlegemChange}
                    placeholder="GEMC-XXXXXXXXXXXXXXX"
                    maxLength={20}
                    error={!!errors.gemno}
                    helperText={errors.gemno}
                    disabled={!gemchecked}
                  />

                </div>


                <div className="po-field">

                  <DatePickerComponent
                    label="GeM Contract Date"
                    id="gemdate"
                    value={gemDate}
                    onChange={(newDate) =>
                      handleDateChange(
                        newDate,
                        setGemDate
                      )
                    }
                    maxDate={today}
                    minDate={minCalDate}
                    disabled={!gemchecked}
                  />

                </div>

              </div>


              {/* =================================================
                  QUANTITY / UNIT / VALUE
              ================================================== */}

              <div className="po-three-fields">

                <div className="po-field">

                  <NumericTextField
                    id="ItemQuantity"
                    label="PO Item Quantity"
                    title="PO Item Quantity"
                    error={errors.qty}
                    value={poQuantity || ""}
                    onChange={handleQuantityChange}
                  />

                </div>


                <div className="po-field">

                  <DropdownfromDatabaseList
                    Options={units}
                    option={unit}
                    setOptionValue={setunit}
                    DisplayItem1="unit"
                    DisplayItem2="unitcode"
                    showKeyInLabel={true}
                  />

                </div>


                <div className="po-field">

                  <NumericTextField
                    id="ItemValue"
                    label="PO Item Value"
                    title="PO Item Value"
                    error={errors.val}
                    value={poValue || ""}
                    onChange={handleValueChange}
                  />

                </div>

              </div>


              {/* =================================================
                  ITEM NAME
              ================================================== */}

              <div className="po-field po-full">

                <CustomTextField
                  label="Enter Item Name (Max 200 Characters)*"
                  value={poItemName || ""}
                  onChange={(e) => {
                    setpoItemName(e.target.value);
                  }}
                  placeholder="Enter Item Name"
                  maxLength={200}
                  multiline={true}
                  minRows={4}
                  error={!!errors.name}
                  helperText={errors.name}
                />

              </div>


              {/* =================================================
                  PARTY DETAILS
              ================================================== */}

              <div className="po-field">

                <CustomTextField
                  label="Party Name (Max 100 Characters)*"
                  value={partyName || ""}
                  onChange={(e) => {
                    setPartyName(
                      e.target.value.toUpperCase()
                    );
                  }}
                  placeholder="Party Name"
                  maxLength={100}
                  error={!!errors.partyName}
                  helperText={errors.partyName}
                />

              </div>


              <div className="po-field">

                <CustomTextField
                  label="Party Contact Number"
                  value={partyContact || ""}
                  onChange={(e) => {
                    setPartyContact(e.target.value);
                  }}
                  placeholder="Party Contact Number"
                  maxLength={10}
                  error={!!errors.partyContact}
                  helperText={errors.partyContact}
                />

              </div>


              <div className="po-field po-full">

                <CustomTextField
                  label="Party Address (Max 200 Characters)*"
                  value={partyAddress || ""}
                  onChange={(e) => {
                    setPartyAddress(
                      e.target.value.toUpperCase()
                    );
                  }}
                  placeholder="Party Address"
                  maxLength={200}
                  multiline={true}
                  minRows={2}
                  error={!!errors.partyAddress}
                  helperText={errors.partyAddress}
                />

              </div>


              {/* =================================================
                  DATES
              ================================================== */}

              <div className="po-field">

                <DatePickerComponent
                  label="PO Date*"
                  id="podate"
                  value={poDate}
                  onChange={(newDate) =>
                    handleDateChange(
                      newDate,
                      setpoDate
                    )
                  }
                  error={errors.errPODate}
                  maxDate={today}
                  minDate={minCalDate}
                />

              </div>


              <div className="po-field">

                <DatePickerComponent
                  label="DP Date*"
                  id="dpdate"
                  value={dpDate}
                  onChange={(newDate) =>
                    handleDateChange(
                      newDate,
                      setdpDate
                    )
                  }
                  error={errors.errDPDate}
                  minDate={
                    poDate
                      ? dayjs(poDate)
                      : minCalDate
                  }
                />

              </div>

            </div>


            {/* =================================================
                EXISTING PO LIST
            ================================================== */}

            {POReturnData.length > 0 && (

              <div className="po-list-section">

                <div className="po-section-title">
                  Existing Purchase Orders
                </div>

                <TablewithSumFooter
                  columns={columns}
                  columnNames={columnNames}
                  data={POReturnData}
                />

              </div>

            )}


            {/* =================================================
                ACTION BUTTONS
            ================================================== */}

            <div className="po-entry-actions">

              <button
                className="
                  po-entry-btn
                  po-save-btn
                "
                type="button"
                onClick={InsertPOData}
                title="Save PO Data"
              >
                Save Data
              </button>


              <button
                className="
                  po-entry-btn
                  po-close-btn
                "
                type="button"
                onClick={handleClose}
                title="Close"
              >
                Close
              </button>

            </div>

          </div>

        </CardContent>

      </Card>

    </div>
  </>
);
}

export default PoPage;
